// extracted by mini-css-extract-plugin
export var modal = "_l2-0";